


export default class Select extends HTMLElement {
  constructor() {
    super();

    // UI
    this.$wrapper = this.querySelector('.c-select_details_wrapper');
    this.$items = this.querySelectorAll('[data-select-item]');
    this.$value = this.querySelector('[data-select-value]');

    // Binding
    this.handleToggle = this.handleToggle.bind(this);
    this.handleItemClick = this.handleItemClick.bind(this);
    this.handleMutation = this.handleMutation.bind(this);
    this.handleDocumentClick = this.handleDocumentClick.bind(this);

    // Data
    this.detailsHeight = 0;
    this.activeObserver = null;
  }

  // =============================================================================
  // Lifecycle methods
  // =============================================================================
  connectedCallback() {
    this.updateDetailsSize();
    this.syncValueFromActiveItem();
    this.bindEvents();
    this.initActiveObserver();
  }

  disconnectedCallback() {
    this.unbindEvents();
    this.destroyActiveObserver();
  }

  // =============================================================================
  // Events
  // =============================================================================
  bindEvents() {
    // Клик по самому компоненту — открываем/закрываем список
    this.addEventListener('click', this.handleToggle);
    // Клик вне select — закрываем
    document.addEventListener('click', this.handleDocumentClick);

    // Клик по элементу списка — меняем значение и закрываем
    this.$items.forEach($item => {
      $item.addEventListener('click', this.handleItemClick);
    });
  }

  unbindEvents() {
    this.removeEventListener('click', this.handleToggle);
    document.removeEventListener('click', this.handleDocumentClick);

    this.$items.forEach($item => {
      $item.removeEventListener('click', this.handleItemClick);
    });
  }

  handleDocumentClick(event) {
    if (!this.contains(event.target) && this.classList.contains('is-open')) {
      this.close();
    }
  }

  handleToggle(event) {
    const target = event.target;

    // Если кликнули по элементу списка — ничего не делаем здесь,
    // обработка будет в handleItemClick
    if (target && target.closest && target.closest('.c-select_details_item')) {
      return;
    }

    this.toggle();
  }

  handleItemClick(event) {
    event.stopPropagation();

    const $item = event.currentTarget;
    const value = $item?.dataset?.value ?? $item?.textContent?.trim();

    if (this.$value && typeof value === 'string') {
      this.$value.textContent = value;
    }

    this.close();
  }

  // =============================================================================
  // Methods
  // =============================================================================
  syncValueFromActiveItem() {
    if (!this.$value) return;
    const $active = Array.from(this.$items).find(el => el.classList.contains('is-active'));
    if ($active) {
      const value = $active.dataset?.value ?? $active.textContent?.trim();
      if (typeof value === 'string') this.$value.textContent = value;
    }
  }

  initActiveObserver() {
    if (!this.$wrapper) return;
    this.activeObserver = new MutationObserver(this.handleMutation);
    this.activeObserver.observe(this.$wrapper, {
      subtree: true,
      attributes: true,
      attributeFilter: ['class']
    });
  }

  destroyActiveObserver() {
    if (this.activeObserver) {
      this.activeObserver.disconnect();
      this.activeObserver = null;
    }
  }

  handleMutation(mutations) {
    const hasClassChange = mutations.some(m =>
      m.type === 'attributes' &&
      m.target.classList?.contains('c-select_details_item') &&
      m.attributeName === 'class'
    );
    if (hasClassChange) this.syncValueFromActiveItem();
  }

  updateDetailsSize() {
    if (!this.$wrapper) return;

    // Запоминаем естественную высоту контента
    const height = this.$wrapper.scrollHeight;
    this.detailsHeight = height;

    // Пробрасываем в CSS-переменную для анимации
    this.$wrapper.style.setProperty('--details-height', `${height}px`);
  }

  open() {
    if (!this.$wrapper) return;
    this.updateDetailsSize();
    this.$wrapper.classList.add('is-open');
    this.classList.add('is-open');
    
  }

  close() {
    if (!this.$wrapper) return;
    this.$wrapper.classList.remove('is-open');
    this.classList.remove('is-open');
  }

  toggle() {
    if (!this.$wrapper) return;
    this.$wrapper.classList.toggle('is-open');
    this.classList.toggle('is-open');
  }
}